<script setup lang="ts">
    import SectionComponent from "@/builder/components/section/SectionComponent.vue";
    import { AllComponents } from "@/builder/client/AllComponents";
    import { ISectionComponent } from "@/builder/interfaces";

    const props = defineProps(["component"]) as { component: ISectionComponent };
</script>

<template>
    <section-component :component="component">
        <template #children>
            <template v-for="component in props.component.components" :key="component.id">
                <component :is="AllComponents[component.type]" :component="component" />
            </template>
        </template>
    </section-component>
</template>
